<template>
  <div class="left">
      <div class="peopleInfo font-MT text-fff">
          <template>
              <div class="topbook">
                  <img :src="bookdetail.iiconUrlMedium" alt=""/>
              </div>
              <p class="name f18 f-fwb text-hidden">{{ bookdetail.iname}}</p>
              <p class="words f14"><i class="mr5">{{bookdetail.words}}</i>{{$lang('authorCenter.stories.words')}} | <i class="mr5">{{bookdetail.contractTypeDesc}}</i></p>
          </template>
      </div>
      <ul class="person-center author-bar">
          <li class="f18 font-MT text-fff mb10" v-for="(item, index) in navlist" :key="item.name">
              <router-link
                      class="text-fff flexible aItem-center"
                      :to="item.url"
              >
                  <img :src="item.icon"/>
                  {{ item.name }}
              </router-link>
          </li>
      </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";
import baseURL from "@/api/env";
export default {
      props: {
        navlist: Array,
        bookdetail: Object
      },
    data () {
        return{
            imgURL: baseURL.IMG,
        }
    },
  computed: mapState({
    info: state => (state.user.img ? state.user.img : null)
  }),
  methods: {

  }
};
</script>

<style lang="scss" scoped>
    @import "@/styles/author.scss";
    .peopleInfo{
        width: 240px;
        margin: auto;
        .topbook{
            text-align: center;
            margin-top: 36px;
            img{
                width: 132px;
                height: 174px;
            }
        }
        .name{
            width: 187px;
            margin: auto;
            margin-top: 25px;
            line-height: 28px;
            line-clamp: 2;
            -webkit-line-clamp: 2;
        }
        .words{
            border-top: 1px solid #3E3E55;
            width: 187px;
            margin: auto;
            margin-top: 12px;
            padding: 12px 20px 0;
        }
    }
    .author-bar{
        margin-top: 30px;
    }
</style>
